// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./blog.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./service.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./gallery.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./contact-us.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./animations.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./footer.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/cursor/white_small.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.__format {
  padding: 0;
  margin: 0;

} 
*::-webkit-scrollbar {
  display: none;
}

.__flex_row {
  display: flex;
  gap: 2em;

}

.__flex_col {
  display: flex;
  flex-direction: column;
  gap: 2em;
}

html {
  font-family: "Poppins", sans-serif !important;

}

body {
  background-color: #030e62;
  color: #ffffff;
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 2 2, default;
  transition: background-color 1s ease;
  width: calc(100vw - (100vw - 100%));
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

#mainContent {
  width: 100%;
  height: 850vh;
  position: relative;
  display: block;
}

#backgroundLines {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: -10;
  overflow: hidden;
}

h1 {
  font-family: "Poppins", sans-serif;
}


.p-text {
  font-size: 16px;
  font-weight: 200;
}

.subheading-text {
  font-size: 22px;
  font-weight: 200;
}

.heading-text {
  font-size: 40px;
  font-weight: 200;
}

.bold {
  font-weight: 400 !important;
}

.text-blue {
  color: #030e62 !important;
}

#sectionTwo {
  display: flex;
  justify-content: center;
  align-items: center;
}

.globe-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.globe-animation {
  border-radius: 100%;
  background-color: #030e62;
  width: 5em;
  z-index: 50;
  opacity: 0;
}

.globe-title {
  font-size: 1.6em;
  font-weight: 100;
  margin: 0;
  text-align: center;
  text-shadow: 0 0 30px #030e62;
}

.line-open-container {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  width: .7em;
}

.line-to-left {
  position: absolute;
  top: 50%;
  transform-origin: top left;
  transform: rotate(55deg);
}

.line-to-right {
  position: absolute;
  top: 50%;
  transform-origin: top right;
  transform: rotate(-55deg);
}

.disable-line-open-container {
  opacity: 0;
}

.sectionOne,
.sectionTwo,
.sectionThree,
.sectionFour,
.sectionFive,
.sectionSix,
.sectionSeven,
.footer {
  width: 100%;
  height: 100vh;
  opacity: 1;
  position: fixed;
}

.sectionOne,
.sectionTwo,
.sectionThree,
.sectionFour,
.sectionFive,
.sectionSeven,
.footer {
  overflow: hidden;
}

.sectionTwo, .sectionThree, .sectionFour{
  z-index: 2;
}

/* All sections except one */
.sectionTwo,
.sectionThree,
.sectionFour,
.sectionFive,
.sectionSix,
.sectionSeven,
.footer {
  top: 100vh;
}

.sectionFour {
  top: 200vh;
  height: 200vh;
}


.sectionFour.passed-section {
  transition: all 1s linear;
}

.passed-section {
  top: -100vh;
  opacity: 0;
}

.big-globe-bg-container {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  z-index: 10;
}

.big-globe-bg {
  position: relative;
  width: 100%;
  object-fit: cover;
  z-index: 10;
}

.service-cards-container {
  position: relative;
  width: 100%;
  height: 80%;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  z-index: 100;
}

.service-card {
  width: 20%;
  position: relative;
  cursor: pointer;
  transition: transform .6s;
}

.service-card:hover {
  transform: scale(1.1);
}


.service-card-icon {
  width: 9em;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -70%);
  z-index: 10;
}

.service-card-bg {
  width: 100%;
  height: 100%;
  padding: .8em 1.5em;
  padding-top: 1em;
  background-color: rgba(3, 13, 85, 0.8);
}

.service-card-text-container {
  color: white;
}

.service-card-name {
  font-size: 1.1em;
  white-space: nowrap;
  font-weight: 100;
  font-weight: 300;
}

.service-card-description {
  font-size: .9em;
  font-weight: 150;
  -webkit-line-clamp: 9;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
}

.companies-container {
  margin-top: 3em;
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3em;
  z-index: 100;
}

.company-logo {
  width: 10em;
  object-fit: contain;
}

.pre-sectionFour {
  width: 100%;
  height: 100vh;
  position: relative;
  mask-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
}

.section-four-container {
  position: relative;
  width: 100%;
  height: 100vh;

  justify-content: flex-start;
  align-items: flex-start;
  gap: .5em;
}

.section-four-title {
  font-size: 2.2em;
  font-weight: 100;
  text-align: start;
  width: 50%;
  margin: 1.8em 0 0 4em;
}

.section-four-description {
  font-size: 1em;
  font-weight: 100;
  text-align: start;
  width: 50%;
  position: relative;
  margin: 0;
  margin-left: 8em;
}

.section-four-description #boxContent {
  font-size: .9em;
}

.section-four-video {
  position: absolute;
  width: 55%;
  top: 0;
  right: 0;
  z-index: -1;
}

.section-four-video>video {
  width: 100%;
}

.hex-container {
  width: 60%;
  position: absolute;
  bottom: 1em;
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  justify-content: space-around;
}

.hex-container-line {
  position: absolute;
  width: 100%;
  height: .5em;
  bottom: .8em;
  mask-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 15%, rgba(0, 0, 0, 1) 85%, rgba(0, 0, 0, 0));
}

.hex-container-line > div {
  position: absolute;
  width: 20%;
  height: .5em;
  background-color: white;
  bottom: 0;
  transition: all 1s ease-in;
  mask-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 15%, rgba(0, 0, 0, 1) 85%, rgba(0, 0, 0, 0));
}

.hex-item {
  cursor: pointer;
  width: 5em;
  height: 10em;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
}

.hex-item-text {
  font-size: .9em;
  font-weight: 100;
  text-align: center;
  text-transform: uppercase;
  opacity: 0.8;
}

.hex-item-active>.hex-item-text {
  opacity: 1;
  font-weight: 300;
}

.hex-item-icon {
  width: 2em;
  height: 2em;
  background-color: white;
  /* hexagon path */
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  position: relative;
}

.hex-item-icon::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 75%;
  height: 75%;
  background-color: #030e62;
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);

  transition: all 1s;
}

.hex-item-active>.hex-item-icon::after {
  width: 0;
  height: 0;
}

.section-five-container {
  position: relative;
  width: 100%;
  height: 100vh;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 4em 3em;
  gap: 0;
}

.section-five-title {
  position: relative;
  left: 3em;
  font-size: 2.2em;
  font-weight: 100;
  text-align: start;
}

.section-five-sub-container {
  position: relative;
  width: 100%;
  height: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.section-five-bottom-text {
  font-size: .9em;
  font-weight: 90;
  width: 20em;
  position: relative;
  margin: 0;
  align-self: flex-end;
}

.section-five-big-text {
  text-align: start;
  width: 25em;
}

.section-five-big-text>.big-text-title {
  font-size: 1.4em;
  font-weight: 300;
}

.section-five-big-text>.p-text {
  font-size: .8em;
  font-weight: 100;
  margin-bottom: 1em;
}

.section-five-img-container {
  width: 16em;
  margin-top: 5em;
}

.section-five-img-container>img {
  width: 100%;
  object-fit: contain;
}


.section-five-marquee {
  margin: 0 auto;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
}

.section-five-marquee span {
  display: inline-block;
  padding-left: 100%;
  animation: marquee 400s linear infinite;
}

@keyframes marquee {
  0% {
      transform: translate(0, 0);
  }

  100% {
      transform: translate(-100%, 0);
  }
}

.section-five-marqueeReverse {
  margin: 0 auto;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
}

.section-five-marqueeReverse span {
  display: inline-block;
  padding-left: 100%;
  animation: marqueeReverse 400s linear infinite;
}

.section-five-movingLines {
  font-size: 5rem;
  font-weight: 100;
  margin: 0 1px;
}

.section-five-servicesButton {
    display: flex;
    flex-direction: row;
    align-items: center;

}


@keyframes marqueeReverse {
  0% {
      transform: translate(-100%, 0);
  }

  100% {
      transform: translate(0, 0);
  }
}

.section-six-container {
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
  color: #030e62;
}

.section-six-texts-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 60%;
  padding: 6em 8em 0;
}

.section-six-title {
  text-transform: uppercase;
  font-size: 2.6em;
  font-weight: 100;
  margin-bottom: 0;
}

.section-six-title>span {
  font-weight: 500;
}

.section-six-description {
  font-size: 1em;
}

.section-six-button {
  text-decoration: none;
  color: #030e62;
  font-size: 1em;
  font-weight: 600;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 1em;
  margin-top: 2em;
}

.section-six-carrousels-container {
  display: flex;
  gap: 2em;
  width: 40%;
  margin-right: 8em;
}

.section-six-third-carrousel {
  display: none;
}

.section-six-imgScroll {
  top: 0rem;
  width: 100%;
  position: relative;
  animation: imgScroll 30s linear infinite;
}

.section-six-imgScrollReverse {
  top: -100rem;
  width: 100%;
  position: relative;
  animation: imgScrollReverse 30s linear infinite;
}

@keyframes imgScroll {
  0% {
      top: 0rem;
  }

  100% {
      top: -200rem;
  }
}


@keyframes imgScrollReverse {
  0% {
      top: -100rem;
  }

  100% {
      top: 10rem;
  }
}

.section-six-projectImg {
  width: 100%;
  object-fit: cover;
  height: 30vw;
}

.footer {
  background-color: #FFFFFF;
}

.footer-container {
  position: relative;
  width: 100%;
  height: 100vh;
  align-items: center;
  margin: 0;
}

.footer-non-absolute {
  position: relative;
  width: 100%;
  align-items: center;
  margin: 0;
  top: 0;
}

.footer-subcontainer-1 {
  display: flex;
  gap: 2em;
}

.footer-title-container {
  width: 25em;
  display: flex;
  flex-direction: column;
  gap: 2em;

  margin: 0;
  margin-top: 6em;
  margin-left: 10em;
}

.footer-title {
  text-align: start;
  width: 100%;
  margin: 0;
  color: #030e62;

  font-size: 2.6em;
  font-weight: 100;
}

.footer-button {
  padding: 1rem;
  background-color: #030e62;
  color: #ffffff;
  border-radius: 0px;
  width: 12em;
  border: none;

  font-weight: 300;
}

.footer-offices-container {
  color: #000000;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding-left: 3em;
  gap: 4em !important;
  z-index: 10;
}

.footer-office {
  width: 20%;
}

.footer-office-title {
  font-size: 1.2em;
  font-weight: 600;
  color: #030e62;
}

.footer-office>p {
  margin: 0;
  margin-bottom: .2em;
  font-size: .9em;
}

.scroll-top-button {
  position: absolute;
  right: 1em;
  top: 50%;
}

.footer-image-and-offices {
  margin-top: 2.2em;
  margin-left: 4em;
}

.footer-image-container {
  top: 35%;
  position: absolute;
  width: 50em;
  object-fit: contain;
}

.footer-image {
  width: 100%;
  object-fit: contain;
}
.footer-image-container>.pos1 {
  position: absolute;
  top: 25%;
  left: 20%;
  z-index: 50;
}
.footer-image-container>.pos2 {
  position: absolute;
  top: 17%;
  left: 55%;
  z-index: 50;
}
.footer-image-container>.pos3 {
  position: absolute;
  top: 36%;
  left: 22%;
  z-index: 50;
}

.footer-hex-container {
    width: 2em;
    height: 2em;
    position: absolute;
    bottom: 2em;
    left: 50%;
    transform: translate(-50%, 0);
    display: flex;
    justify-content: space-around;
}

.footer-hex-container::before {
  content: "";
  z-index: 25;
  position: absolute;
  width: 2em;
  height: 2em;
  z-index: 0;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  background-color: #030e62;

  clip-path: polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);
}


.footer-hex {
  z-index: 10;
  width: 100%;
  height: 100%;
  overflow: hidden;

  position: relative;
  background-color: #030e62;
  clip-path: polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);
}

.footer-hex::before {
  content: "";
  z-index: 25;
  position: absolute;
  width: 1.6em;
  height: 1.6em;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  background-color: #fff;

  clip-path: polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);
}

.footer-hex::after {
  content: "";
  z-index: 25;
  position: absolute;
  width: 1em;
  height: 1em;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  background-color: #030e62;

  clip-path: polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);
}

.lets-meet-container {
  color: black;
  position: absolute;
  bottom: 5.5em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: .5em;
}

.lets-meet-title {
  font-size: 1.2em;
  font-weight: 600;
  color: #030e62;

  margin: 0;
  padding: 0;
}

.lets-meet-text {
  font-size: 1em;
  font-weight: 300;
  margin: 0;
  padding: 0;
}

.lets-meet-line-decoration {
  margin-top: 1em;
  width: 1.5em;
  height: .5em;
  background-color: #030e62;
}

.lets-meet-button {
  background-color: transparent;
  color: #030e62;
  font-size: 1.1em;
  font-weight: 600;
  padding: 0;
  border: none;
  cursor: pointer;
  text-decoration: underline;
}

.footer-appbar {
  width: 100%;
  position: absolute;
  bottom: 0;
  background-color: #FFFFFF;
  border-top: 1px solid  rgba(0, 0, 0, 0.2);

  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .5em 1em;
}

.footer-appbar-rights {
  font-size: .8em;
  font-weight: 500;
  color: #000;

}

.footer-appbar-links {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1em;
}

.footer-appbar-first-links, .footer-appbar-second-links {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1em;
}

.footer-appbar-first-links>a, .footer-appbar-second-links>a {
  /* nowrap text */
  white-space: nowrap;
  color: #000;
  font-size: .9em;
  text-decoration: none;
  font-weight: 400;
}

.footer-appbar-second-links>a  {
  font-weight: 300;
}

.footer-appbar-links > .divider {
  width: 1px;
  height: 1em;
  background-color: rgba(0, 0, 0, 0.2);
} 

.footer-appbar-social {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0;
}

.footer-social-icon {
  color: #17216f;
}

.center {
  width: 500px;
  height: 500px;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  align-items: center;
  position: relative;
  bottom: 255px;
}

.container {
  width: 40px;
  height: 40px;
  background: white;
  position: absolute;
  top: 50%;
  left: 50%;
  overflow: hidden;
  transform: translate(-50%, -50%);
  clip-path: polygon(0% 50%, 25% 95%, 75% 95%, 100% 50%, 75% 5%, 25% 5%);
  clip-path: polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);
}


.border {
  width: 30px;
  height: 30px;
  background: #030e62;
  position: absolute;
  top: 50%;
  left: 50%;
  overflow: hidden;
  transform: translate(-50%, -50%);
  clip-path: polygon(0% 50%, 25% 95%, 75% 95%, 100% 50%, 75% 5%, 25% 5%);
  clip-path: polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);
}


.dotfill {
  width: 0px;
  height: 0px;
  background: white;
  position: absolute;
  top: 50%;
  left: 50%;
  overflow: hidden;
  transform: translate(-50%, -50%);
  clip-path: polygon(0% 50%, 25% 95%, 75% 95%, 100% 50%, 75% 5%, 25% 5%);
  clip-path: polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);
  animation: fillHex 0.4s linear forwards;
  animation-delay: 7s;
}

.dot2 {
  animation-delay: 15s;
}


.dot3 {
  animation-delay: 27s;
}

@keyframes fillHex {
  0% {
    width: 0px;
    height: 0px
  }

  100% {
    width: 40px;
    height: 320px
  }
}

.logo-colored {
  position: fixed;
  top: 0;
  left: -1em;
  margin: 0;
  padding: 0;
  width: 9em;
  transition: all .8s;
  opacity: 0;
  z-index: 100;
}

.logo-white,
.logo-black {
  width: 4em;
  position: fixed;
  left: 1.65em;
  top: .5em;
  transition: all .8s;
  opacity: 0;
  z-index: 100;
}


.logo-colored-appears,
.logo-white-appears,
.logo-black-appears {
  opacity: 1;
}

.logoVideo-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;
}

.logoVideo-start {
  position: absolute;
  opacity: 0;
}

.logo-heading {
  z-index: 20;
  text-transform: uppercase;
  font-size: 3.5rem;
  opacity: 0;
}

.weare-heading-start {
  font-family: "Roboto", sans-serif;
  font-weight: 100;
  font-stretch: 150%;
}

.weare-heading-out {

  font-weight: 100;
  font-stretch: 150%;
}

.cubes-heading-start {

  font-weight: 100;
  width: 5em;
  font-stretch: 150%;
}

.cubes-heading-out {

  font-weight: 100;
  font-stretch: 150%;
}

.navigation-container {
  position: fixed;
  top: 1em;
  right: 1em;
  z-index: 100;
}

.navigation-button {
  cursor: pointer;
  opacity: 0.7;
  transition: all .3s;
}

.navigation-button:hover {
  opacity: 1;
}

.menu-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.item-container {
  height: 50vh;
  width: 10rem;
  display: flex;
  flex-direction: column;
  opacity: .5;
  transition: all .3s;
  cursor: pointer;
}

.item-container:hover {
  opacity: 1;
}

.row {
  flex-direction: row;
}

.item {
  font-weight: 200;
  font-size: 50px;
  margin: 0;
}

.item-top {
  justify-content: flex-start;
}

.item-bottom {
  justify-content: flex-end;
}

.item-top-text {
  font-weight: 200;
  text-transform: uppercase;
  font-size: 1em;
  margin: 0;
}

.item-container-active {
  opacity: 1;
}

.item-bottom-decoration {
  background-color: #FFFFFF;
  width: 1.8em;
  height: .3em;
  margin-top: .5em;
}

.item2 {
  font-weight: 100;
  font-size: 35px;
  opacity: 0.5;
  cursor: pointer;
}

.item2:hover {
  opacity: 1;
}

.close-button {
  cursor: pointer;
  transition: all .3s;
  opacity: 0.7;
}

.close-button:hover {
  opacity: 1;
}


.right {
  margin-left: 6%;
  width: 3px;
  height: 0;
  right: 1rem;
  position: relative;
  background: linear-gradient(180deg,
      transparent 30%,
      rgba(255, 255, 255, 0.5),
      rgb(255, 255, 255));
}

.speed-1 {
  animation: animateRight 3s linear infinite;
}

.speed-2 {
  animation: animateRight 5s linear infinite;
}

.speed-3 {
  animation: animateRight 7s linear infinite;
}

.speed-4 {
  animation: animateRight 9s linear infinite;
}

.speed-5 {
  animation: animateRight 11s linear infinite;
}

.speed-6 {
  animation: animateRight 13s linear infinite;
}

.delay-1 {
  animation-delay: 1s;
}

.delay-2 {
  animation-delay: 2s;
}

.delay-3 {
  animation-delay: 3s;
}

.delay-4 {
  animation-delay: 4s;
}

.delay-5 {
  animation-delay: 5s;
}

.delay-6 {
  animation-delay: 6s;
}


@keyframes animateRight {

  0%,
  25% {
    opacity: 0;
    height: 0;
  }

  40% {
    opacity: 1;
    height: 100%;
  }

  55%,
  100% {
    height: 100%;
    opacity: 0;
  }
}

.hide {
  z-index: 2;
  width: 100%;
  position: relative;
  margin: 0 auto;
  top: 2px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  text-align: center;
}

.hide2 {
  z-index: 2;
  background-color: #030e62;
  width: 100%;
  height: 500px;
  position: relative;
  margin: 0 auto;
}

.line-container {
  width: 100%;
  height: 300px;
  margin-bottom: 350px;
  position: relative;
}

.wrap {
  opacity: 0.5;
  z-index: 1;
  width: 100%;
  height: 160%;
  margin: 0 auto;
  overflow: hidden;
}

.line {
  height: 2px;
  background-color: white;
  padding: 1px;
  margin: 0 auto;
}


.line2 {
  z-index: 0;
  height: 1px;
  padding: 1px;
  margin: 0 auto;
  background-color: white;
  opacity: 0.5;
}

.line-animate {
  animation: lineH 1.5s infinite linear;
}


.line-animate-delay {
  animation-delay: 0.5s;
}

.left-rotate {
  transform: rotate(30deg);
  top: 76px;
  position: relative;
  left: 136px;
}

.left-rotate2 {
  transform: rotate(30deg);
  position: relative;
  top: 68px;
  left: 133px;
}

.right-rotate {
  transform: rotate(-30deg);
  position: relative;
  bottom: -55px;
  left: -107px;
}

.right-rotate2 {
  transform: rotate(-30deg);
  position: relative;
  right: 124px;
  bottom: -59px;
}

.line-center-1 {
  transform: rotate(90deg);
  position: relative;
}

.line-center-2 {
  transform: rotate(90deg);
  position: relative;
}



@keyframes lineH {
  0% {
    width: 0%;
    opacity: 0;
  }

  10% {
    opacity: 1;
  }

  100% {
    width: 100%;
    opacity: 0;
  }
}


.first-center {
  height: 0px;
  width: 50%;
  border-right: 3px solid white;
  position: absolute;
  top: 0px
}

.background {

  height: 100vh !important;
  opacity: 0.5;
}

.first-center-animate {
  animation: firstCenter 2s linear infinite;
}

@keyframes firstCenter {
  0% {
    height: 0px;
    opacity: 0;
  }

  10% {
    height: 0px;
    opacity: 1;
  }

  100% {
    height: 100vh;
  }
}

.hide {
  display: 'hidden'
}

.global-margin {
  margin: 0 10rem;
}


#borderLeft {
  border-left: 5px solid white;
  position: absolute;
  height: 30px;
  top: 0;
}

#borderBottom {
  border-bottom: 5px solid white;
  width: 30px
}

#boxContent {
  width: 25rem;
  padding-left: 2em;
  font-size: 16px;
  line-height: 19px;
  font-weight: 200;
}

.section-six-margin {
  margin: 10rem;
}

.s7-flex {
  display: flex;
}

.white-bg {
  background-color: white;
}

.s7-height {
  height: 100vh;
}

.s7-width {
  width: 100%;
}

.s7-transition {
  transition: background-color 1s ease;
}


/* blinking hexagon */

.white {
  background: white;
}

.blue {
  background: #030e62;
}

.white-text {
  color: white !important;
}

.w-120 {
  width: 60px;
  height: 60px;
}

.w-100 {
  width: 35px;
  height: 35px;
}

.w-80 {
  width: 31px;
  height: 31px;
}

.w-60 {
  width: 20px;
  height: 20px;
}

.animateHex {
  animation: blink 2s linear infinite;
}


@keyframes blink {
  0% {
    width: 0px;
    height: 0px;
  }

  100% {
    width: 65px;
    height: 65px;
    opacity: 0;
  }
}


.w-128 {
  width: 128px;
  height: 128px;
  opacity: 0.1;
  background: #FFFFFF;
  position: relative;
  top: 184px;
  z-index: 2;
}

.logo-ignore-position {
  position: absolute;
}


@media screen and (max-width: 821px) {
  .logo-colored {
    top: 1em;
    left: 0;
    width: 6em;
  }
  
  .logo-white,
  .logo-black {
    width: 2.8em;
    left: 1.65em;
    top: 1.2em;
    transition: all .8s;
    opacity: 0;
    z-index: 100;
  }
  
  .navigation-container {
    top: 2em;
    right: 2em;
  }

  
  .menu-container {
    flex-direction: column;
    align-items: flex-start;
    height: 100vh;
    padding-left: 3em;
    padding-top: 5em;
  }

  .item-container {
    height: auto;
  }

  .item {
    font-size: 25px;
    margin: 0;
  }

  .item-top {
    justify-content: flex-start;
  }

  .item-bottom {
    justify-content: flex-start;
  }

  .item2 {
    font-weight: 100;
    font-size: 25px;
    justify-content: flex-start;
    margin: 0;
    padding: 0;
  }

  #mainContent {
    width: 100%;
    height: auto;
  }

  .logoVideo-container {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .logoVideo-start {
    position: absolute;
    opacity: 0;
  }



  .logo-heading {
    font-size: 2.5em;
  }

  @keyframes weare-heading-start {
    0% {
      opacity: 0;
      transform: translate(0, -0%);
    }

    100% {
      transform: translate(0, -250%);
      opacity: 1;
    }
  }

  @keyframes were-heading-out {
    0% {
      opacity: 1;
      transform: translate(0, -250%);
    }

    100% {
      transform: translate(0, -0%);
      opacity: 0;
    }
  }

  @keyframes cubes-heading-start {
    0% {
      opacity: 0;
      transform: translate(0, -0%);
    }

    100% {
      transform: translate(0, 300%);
      opacity: 1;
    }
  }

  @keyframes cubes-heading-out {
    0% {
      opacity: 1;
      transform: translate(0, 300%);
    }

    100% {
      transform: translate(0, -0%);
      opacity: 0;
    }
  }

  .big-globe-bg-container {
    width: auto;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .big-globe-bg {
    width: auto;
    height: 100vh;
    object-fit: contain;
    z-index: 10;
  }

  .service-cards-container {
    width: 100%;
    height: 75%;
    display: flex;
    padding-top: 8em;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;

    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 100;
  }

  .service-card {
    width: 80%;
    padding: .8em 1.5em;
    margin: 0 auto;
  }

  .service-card-icon {
    width: 6em;
  }

  .companies-container {
    width: 100%;
    height: 25%;
    display: flex;
    flex-wrap: wrap;
    margin-top: 1em;
    justify-content: center;
    padding: 2em 0;
  }

  .company-logo {
    width: 7em;
    object-fit: contain;
  }

  .section-four-container {
    justify-content: space-between;
    align-items: space-between;
  }

  .pre-sectionFour {
    height: auto;
  }

  .section-four-title {
    font-size: 1.4em;
    padding: 0 1em;
    margin: 0;
    margin-top: 1.5em;
    width: 100%;
  }

  .section-four-description {
    display: none;
  }

  .section-four-video {
    position: absolute;
    width: 100%;
    height: auto;
    margin-top: 10em;
  }

  .section-four-video>video {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }


  .hex-container {
    width: 70%;
    height: 10em;
    position: relative;
    bottom: 2em;
    display: flex;
    justify-content: space-around;

    padding: 0;
    margin: 0;
  }

  .hex-item-text {
    font-size: 1.7em;
    font-weight: 300;
    opacity: 0;
    transition: all 1s;
    position: absolute;
    bottom: 2em;
    left: 50%;
    transform: translate(-50%, 0);
  }

  .hex-item-active>.hex-item-text {
    opacity: 0;
  }
  
  .hex-item-text-active>.hex-item-text {
    opacity: 1;
  }

  .sectionOne {
    top: 0;
  }

  .sectionThree {
    margin-top: 250vh;
  }
  
  .sectionThree, .sectionFour, .sectionFive {
    position: relative;
    top: 0;
    opacity: 1;
    height: auto;
  }

  .sectionFive {
    height: auto;
    overflow: hidden;
  }

  .logo-white-mobile {
    position: absolute;
    width: 2.8em;
    left: 1.65em;
    top: 1.2em;
    transition: all .8s;
    z-index: 100;
  }

  .section-five-container,
  .section-six-container,
  .footer-container {
    position: relative;
    width: 100%;
    height: auto;
    overflow-y: auto;
    overflow-x: hidden;

    justify-content: center;
    align-items: center;

    flex-direction: column;

    padding: 0 3em 3em;
  }

  .section-five-title {
    left: 0;
    top: 3em;
    font-size: 1.4em;
    font-weight: 100;
  }

  .section-five-sub-container {
    position: relative;
    width: 100%;
    height: 60%;
    display: flex;
    flex-direction: column;
  }

  .section-five-bottom-text {
    display: none;
  }

  .section-five-big-text {
    text-align: start;
    width: 100%;
    order: 1;
  }

  .section-five-big-text>.big-text-title {
    font-size: 1.4em;
    font-weight: 300;
  }

  .section-five-big-text>.p-text {
    font-size: .8em;
    font-weight: 100;
    margin-bottom: 1em;
  }

  .section-five-img-container {
    width: 16em;
    margin-top: 5em;
    order: 2;
  }

  .section-five-img-container>img {
    width: 100%;
    object-fit: contain;
  }

  .section-six-container {
    display: flex;
    flex-direction: column;

    background-color: transparent;
    color: #FFFFFF;
  }

  .section-six-texts-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    padding: 0;
  }

  .section-six-title {
    top: 3em;
    font-size: 1.4em;
    font-weight: 100;
  }

  .section-six-title>span {
    font-weight: 500;
  }

  .section-six-description {
    font-size: .8em;
    font-weight: 100;
  }

  .section-six-button {
    text-decoration: none;
    color: #ffffff;
    font-size: 1em;
    font-weight: 600;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    gap: 1em;
    margin-top: 2em;
  }

  .section-six-first-carrousel,
  .section-six-second-carrousel {
    display: none;
  }

  .section-six-carrousels-container {
    width: 100%;
    margin-top: 0;
    margin-right: 0;
  }

  .section-six-third-carrousel {
    top: 0rem;
    width: auto;
    display: flex;
    position: relative;
    height: 25em;
    margin-top: 2em;
    gap: 25vw;
    animation: imgScroll 40s linear infinite;
  }

  .third-carrousel-item {
    width: 75vw;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }

  .third-carrousel-item>img {
    width: 100%;
    height: 25em;
    object-fit: cover;
    overflow: hidden;
    margin-bottom: 1em;
  }

  @keyframes imgScroll {
    0% {
      left: 0em;
    }
    100% {
      left: -200em;
    }
  }

  .footer.footer-non-absolute {
    height: auto;
  }
  
  .footer-container {
    background-color: #ffffff;
    padding-bottom: 0;
  }

  .footer-subcontainer-1 {
    position: relative;
    width: 100%;
    justify-content: center;
    flex-direction: column;
  }

  .footer-title-container {
    width: 25em;
    gap: 2em;
    margin: 0;
    margin-top: 3em;
  }

  .footer-title {
    text-align: start;
    width: 100%;
    color: #030e62;

    font-size: 1.8em;
    font-weight: 100;
  }

  .footer-button {
    padding: .8em 1em;
  }

  .footer-image-and-offices {
    margin-top: 2.2em;
    margin-left: 0;

    width: 100%;
  }

  .footer-offices-container {
    color: #000000;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    padding-left: 0;
  }

  .footer-offices-carrousel {
    width: 100%;
    height: 50%;
    display: flex;
    padding-top: 0;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;

    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 100;
  }

  .footer-office {
    width: 100%;
    padding: .8em 1.2em;
    margin: 0 auto;
    border: 1px solid #bdbfec;
  }

  .footer-office-title {
    font-size: 1.2em;
    font-weight: 600;
    color: #030e62;
  }

  .footer-office>p {
    margin: 0;
    margin-bottom: .2em;
    font-size: .9em;
  }


  .footer-image-container {
    top: 0;
    position: relative;
    width: calc(100% + 6em);
    margin: 0 -3em;
    object-fit: contain;
  }

  .footer-image {
    width: 100%;
    object-fit: contain;
  }

  .lets-meet-container {
    position: static;
  }

  .scroll-top-button {
    display: none;
  }

  .footer-appbar {
    position: relative;
    flex-direction: column;
    width: calc(100% + 6em);
    padding: 1em 3em;

    justify-content: flex-start;
    align-items: flex-start;
    gap: 1em;
  }
  
  .footer-appbar-rights {
    order: 2;
  }
  
  .footer-appbar-links {
    width: 100%;
    order: 1;

    justify-content: flex-start;
    align-items: flex-start;
  }
  
  .footer-appbar-first-links, .footer-appbar-second-links {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 0;
  }
  
  .footer-appbar-first-links>a, .footer-appbar-second-links>a {
    font-size: 1em;
    font-weight: 500;
    margin-bottom: .5em;
  }
  .footer-appbar-second-links>a {
    font-weight:300;
  }

  .footer-appbar-links > .divider {
    display: none;
  } 
  
  .footer-appbar-social {
    display: flex;
    align-items: flex-start;
    order: 3;
    gap: 0;
  }

  
.footer-social-icon {
  width: 1.5em !important;
  height: 1.5em !important;
  color: #17216f;
}

.footer-hex-container {
  width: 1.5em;
  height: 1.5em;
}
.footer-hex-container::before {
  width: 1.5em;
  height: 1.5em;
}

.footer-hex::before {
  width: 1.2em;
  height: 1.2em;
}

.footer-hex::after {
  width: .8em;
  height: .8em;
}

.footer-image-container>.pos1,.contact-us-image-container>.pos1 {
  position: absolute;
  top: 25%;
  left: 20%;
  z-index: 50;
}
.footer-image-container>.pos3,.contact-us-image-container>.pos3 {
  position: absolute;
  top: 36%;
  left: 22%;
  z-index: 50;
}
.footer-image-container>.pos2,.contact-us-image-container>.pos2 {
  position: absolute;
  top: 17%;
  left: 55%;
  z-index: 50;
}

}

@media screen and (min-width :821px) and (max-width: 1025px) {
  .sectionOne, .sectionTwo, .sectionThree, .sectionFour, .sectionFive, .sectionSix, .footer {
    font-size: .8em;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AASA;EACE,UAAU;EACV,SAAS;;AAEX;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;;AAEV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6CAA6C;;AAE/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,4DAA4D;EAC5D,oCAAoC;EACpC,mCAAmC;EACnC,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;;AAGA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;;;;;EAQE,WAAW;EACX,aAAa;EACb,UAAU;EACV,eAAe;AACjB;;AAEA;;;;;;;EAOE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;;;;;;;EAOE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,2FAA2F;AAC7F;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;;EAEb,2BAA2B;EAC3B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,6BAA6B;EAC7B,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,wHAAwH;AAC1H;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,0BAA0B;EAC1B,wHAAwH;AAC1H;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,wEAAwE;EACxE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,wEAAwE;;EAExE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;;AAGA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE;MACI,0BAA0B;EAC9B;;EAEA;MACI,8BAA8B;EAClC;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;;AAEvB;;;AAGA;EACE;MACI,8BAA8B;EAClC;;EAEA;MACI,0BAA0B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE;MACI,SAAS;EACb;;EAEA;MACI,YAAY;EAChB;AACF;;;AAGA;EACE;MACI,YAAY;EAChB;;EAEA;MACI,UAAU;EACd;AACF;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,MAAM;AACR;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;;EAER,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,cAAc;;EAEd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;;EAEZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,6BAA6B;IAC7B,aAAa;IACb,6BAA6B;AACjC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;;EAEV,QAAQ;EACR,SAAS;EACT,gCAAgC;;EAEhC,yBAAyB;;EAEzB,sEAAsE;AACxE;;;AAGA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;;EAEhB,kBAAkB;EAClB,yBAAyB;EACzB,sEAAsE;AACxE;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;;EAEb,QAAQ;EACR,SAAS;EACT,gCAAgC;;EAEhC,sBAAsB;;EAEtB,sEAAsE;AACxE;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;;EAEX,QAAQ;EACR,SAAS;EACT,gCAAgC;;EAEhC,yBAAyB;;EAEzB,sEAAsE;AACxE;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;;EAEd,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,yCAAyC;;EAEzC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;;AAEb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,sEAAsE;EACtE,sEAAsE;AACxE;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,sEAAsE;EACtE,sEAAsE;AACxE;;;AAGA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,sEAAsE;EACtE,sEAAsE;EACtE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;;AAGA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;IACV;EACF;;EAEA;IACE,WAAW;IACX;EACF;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,UAAU;EACV,SAAS;EACT,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,eAAe;EACf,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;;AAGA;;;EAGE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB;;;yBAGuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;;EAEE;;IAEE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;;IAEE,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;;AAGA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;;AAGA;EACE,qBAAqB;AACvB;;AAEA;EAGE,wBAAwB;EACxB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EAGE,wBAAwB;EACxB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EAGE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EAGE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;;;AAIA;EACE;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;AACF;;;AAGA;EACE,WAAW;EACX,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB;AACF;;AAEA;;EAEE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,MAAM;AACR;;AAEA;EACE,8BAA8B;EAC9B;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;;AAGA,qBAAqB;;AAErB;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;;AAGA;EACE;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;AACF;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE;IACE,QAAQ;IACR,OAAO;IACP,UAAU;EACZ;;EAEA;;IAEE,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;;;EAGA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;;;EAIA;IACE,gBAAgB;EAClB;;EAEA;IACE;MACE,UAAU;MACV,4BAA4B;IAC9B;;IAEA;MACE,8BAA8B;MAC9B,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;MACV,8BAA8B;IAChC;;IAEA;MACE,4BAA4B;MAC5B,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;MACV,4BAA4B;IAC9B;;IAEA;MACE,6BAA6B;MAC7B,UAAU;IACZ;EACF;;EAEA;IACE;MACE,UAAU;MACV,6BAA6B;IAC/B;;IAEA;MACE,4BAA4B;MAC5B,UAAU;IACZ;EACF;;EAEA;IACE,WAAW;IACX,MAAM;IACN,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,2BAA2B;;IAE3B,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,WAAW;IACX,aAAa;IACb,eAAe;IACf,eAAe;IACf,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;;EAGA;IACE,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,6BAA6B;;IAE7B,UAAU;IACV,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,6BAA6B;EAC/B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,MAAM;EACR;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,YAAY;EACd;;EAEA;;;IAGE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;;IAElB,uBAAuB;IACvB,mBAAmB;;IAEnB,sBAAsB;;IAEtB,kBAAkB;EACpB;;EAEA;IACE,OAAO;IACP,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;;IAEtB,6BAA6B;IAC7B,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,SAAS;IACT,wCAAwC;EAC1C;;EAEA;IACE,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE;MACE,SAAS;IACX;IACA;MACE,YAAY;IACd;EACF;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,QAAQ;IACR,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,cAAc;;IAEd,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,cAAc;;IAEd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,aAAa;IACb,cAAc;IACd,4BAA4B;IAC5B,2BAA2B;;IAE3B,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,mBAAmB;IACnB,eAAe;EACjB;;;EAGA;IACE,MAAM;IACN,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;;IAEhB,2BAA2B;IAC3B,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,QAAQ;;IAER,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,MAAM;EACR;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,MAAM;EACR;;;AAGF;EACE,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');\n\n@import url(\"./blog.css\");\n@import url(\"./service.css\");\n@import url(\"./gallery.css\");\n@import url(\"./contact-us.css\");\n@import url(\"./animations.css\");\n@import url(\"./footer.css\");\n\n.__format {\n  padding: 0;\n  margin: 0;\n\n} \n*::-webkit-scrollbar {\n  display: none;\n}\n\n.__flex_row {\n  display: flex;\n  gap: 2em;\n\n}\n\n.__flex_col {\n  display: flex;\n  flex-direction: column;\n  gap: 2em;\n}\n\nhtml {\n  font-family: \"Poppins\", sans-serif !important;\n\n}\n\nbody {\n  background-color: #030e62;\n  color: #ffffff;\n  cursor: url('../assets/cursor/white_small.png') 2 2, default;\n  transition: background-color 1s ease;\n  width: calc(100vw - (100vw - 100%));\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n#mainContent {\n  width: 100%;\n  height: 850vh;\n  position: relative;\n  display: block;\n}\n\n#backgroundLines {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  z-index: -10;\n  overflow: hidden;\n}\n\nh1 {\n  font-family: \"Poppins\", sans-serif;\n}\n\n\n.p-text {\n  font-size: 16px;\n  font-weight: 200;\n}\n\n.subheading-text {\n  font-size: 22px;\n  font-weight: 200;\n}\n\n.heading-text {\n  font-size: 40px;\n  font-weight: 200;\n}\n\n.bold {\n  font-weight: 400 !important;\n}\n\n.text-blue {\n  color: #030e62 !important;\n}\n\n#sectionTwo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.globe-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.globe-animation {\n  border-radius: 100%;\n  background-color: #030e62;\n  width: 5em;\n  z-index: 50;\n  opacity: 0;\n}\n\n.globe-title {\n  font-size: 1.6em;\n  font-weight: 100;\n  margin: 0;\n  text-align: center;\n  text-shadow: 0 0 30px #030e62;\n}\n\n.line-open-container {\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, 0);\n  width: .7em;\n}\n\n.line-to-left {\n  position: absolute;\n  top: 50%;\n  transform-origin: top left;\n  transform: rotate(55deg);\n}\n\n.line-to-right {\n  position: absolute;\n  top: 50%;\n  transform-origin: top right;\n  transform: rotate(-55deg);\n}\n\n.disable-line-open-container {\n  opacity: 0;\n}\n\n.sectionOne,\n.sectionTwo,\n.sectionThree,\n.sectionFour,\n.sectionFive,\n.sectionSix,\n.sectionSeven,\n.footer {\n  width: 100%;\n  height: 100vh;\n  opacity: 1;\n  position: fixed;\n}\n\n.sectionOne,\n.sectionTwo,\n.sectionThree,\n.sectionFour,\n.sectionFive,\n.sectionSeven,\n.footer {\n  overflow: hidden;\n}\n\n.sectionTwo, .sectionThree, .sectionFour{\n  z-index: 2;\n}\n\n/* All sections except one */\n.sectionTwo,\n.sectionThree,\n.sectionFour,\n.sectionFive,\n.sectionSix,\n.sectionSeven,\n.footer {\n  top: 100vh;\n}\n\n.sectionFour {\n  top: 200vh;\n  height: 200vh;\n}\n\n\n.sectionFour.passed-section {\n  transition: all 1s linear;\n}\n\n.passed-section {\n  top: -100vh;\n  opacity: 0;\n}\n\n.big-globe-bg-container {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 100%;\n  z-index: 10;\n}\n\n.big-globe-bg {\n  position: relative;\n  width: 100%;\n  object-fit: cover;\n  z-index: 10;\n}\n\n.service-cards-container {\n  position: relative;\n  width: 100%;\n  height: 80%;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-around;\n  z-index: 100;\n}\n\n.service-card {\n  width: 20%;\n  position: relative;\n  cursor: pointer;\n  transition: transform .6s;\n}\n\n.service-card:hover {\n  transform: scale(1.1);\n}\n\n\n.service-card-icon {\n  width: 9em;\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, -70%);\n  z-index: 10;\n}\n\n.service-card-bg {\n  width: 100%;\n  height: 100%;\n  padding: .8em 1.5em;\n  padding-top: 1em;\n  background-color: rgba(3, 13, 85, 0.8);\n}\n\n.service-card-text-container {\n  color: white;\n}\n\n.service-card-name {\n  font-size: 1.1em;\n  white-space: nowrap;\n  font-weight: 100;\n  font-weight: 300;\n}\n\n.service-card-description {\n  font-size: .9em;\n  font-weight: 150;\n  -webkit-line-clamp: 9;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.companies-container {\n  margin-top: 3em;\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3em;\n  z-index: 100;\n}\n\n.company-logo {\n  width: 10em;\n  object-fit: contain;\n}\n\n.pre-sectionFour {\n  width: 100%;\n  height: 100vh;\n  position: relative;\n  mask-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));\n}\n\n.section-four-container {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: .5em;\n}\n\n.section-four-title {\n  font-size: 2.2em;\n  font-weight: 100;\n  text-align: start;\n  width: 50%;\n  margin: 1.8em 0 0 4em;\n}\n\n.section-four-description {\n  font-size: 1em;\n  font-weight: 100;\n  text-align: start;\n  width: 50%;\n  position: relative;\n  margin: 0;\n  margin-left: 8em;\n}\n\n.section-four-description #boxContent {\n  font-size: .9em;\n}\n\n.section-four-video {\n  position: absolute;\n  width: 55%;\n  top: 0;\n  right: 0;\n  z-index: -1;\n}\n\n.section-four-video>video {\n  width: 100%;\n}\n\n.hex-container {\n  width: 60%;\n  position: absolute;\n  bottom: 1em;\n  left: 50%;\n  transform: translate(-50%, 0);\n  display: flex;\n  justify-content: space-around;\n}\n\n.hex-container-line {\n  position: absolute;\n  width: 100%;\n  height: .5em;\n  bottom: .8em;\n  mask-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 15%, rgba(0, 0, 0, 1) 85%, rgba(0, 0, 0, 0));\n}\n\n.hex-container-line > div {\n  position: absolute;\n  width: 20%;\n  height: .5em;\n  background-color: white;\n  bottom: 0;\n  transition: all 1s ease-in;\n  mask-image: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 15%, rgba(0, 0, 0, 1) 85%, rgba(0, 0, 0, 0));\n}\n\n.hex-item {\n  cursor: pointer;\n  width: 5em;\n  height: 10em;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-direction: column;\n}\n\n.hex-item-text {\n  font-size: .9em;\n  font-weight: 100;\n  text-align: center;\n  text-transform: uppercase;\n  opacity: 0.8;\n}\n\n.hex-item-active>.hex-item-text {\n  opacity: 1;\n  font-weight: 300;\n}\n\n.hex-item-icon {\n  width: 2em;\n  height: 2em;\n  background-color: white;\n  /* hexagon path */\n  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);\n  position: relative;\n}\n\n.hex-item-icon::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 75%;\n  height: 75%;\n  background-color: #030e62;\n  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);\n\n  transition: all 1s;\n}\n\n.hex-item-active>.hex-item-icon::after {\n  width: 0;\n  height: 0;\n}\n\n.section-five-container {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding: 0 4em 3em;\n  gap: 0;\n}\n\n.section-five-title {\n  position: relative;\n  left: 3em;\n  font-size: 2.2em;\n  font-weight: 100;\n  text-align: start;\n}\n\n.section-five-sub-container {\n  position: relative;\n  width: 100%;\n  height: 60%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.section-five-bottom-text {\n  font-size: .9em;\n  font-weight: 90;\n  width: 20em;\n  position: relative;\n  margin: 0;\n  align-self: flex-end;\n}\n\n.section-five-big-text {\n  text-align: start;\n  width: 25em;\n}\n\n.section-five-big-text>.big-text-title {\n  font-size: 1.4em;\n  font-weight: 300;\n}\n\n.section-five-big-text>.p-text {\n  font-size: .8em;\n  font-weight: 100;\n  margin-bottom: 1em;\n}\n\n.section-five-img-container {\n  width: 16em;\n  margin-top: 5em;\n}\n\n.section-five-img-container>img {\n  width: 100%;\n  object-fit: contain;\n}\n\n\n.section-five-marquee {\n  margin: 0 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  position: relative;\n}\n\n.section-five-marquee span {\n  display: inline-block;\n  padding-left: 100%;\n  animation: marquee 400s linear infinite;\n}\n\n@keyframes marquee {\n  0% {\n      transform: translate(0, 0);\n  }\n\n  100% {\n      transform: translate(-100%, 0);\n  }\n}\n\n.section-five-marqueeReverse {\n  margin: 0 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  position: relative;\n}\n\n.section-five-marqueeReverse span {\n  display: inline-block;\n  padding-left: 100%;\n  animation: marqueeReverse 400s linear infinite;\n}\n\n.section-five-movingLines {\n  font-size: 5rem;\n  font-weight: 100;\n  margin: 0 1px;\n}\n\n.section-five-servicesButton {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n}\n\n\n@keyframes marqueeReverse {\n  0% {\n      transform: translate(-100%, 0);\n  }\n\n  100% {\n      transform: translate(0, 0);\n  }\n}\n\n.section-six-container {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  background-color: #FFFFFF;\n  color: #030e62;\n}\n\n.section-six-texts-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 60%;\n  padding: 6em 8em 0;\n}\n\n.section-six-title {\n  text-transform: uppercase;\n  font-size: 2.6em;\n  font-weight: 100;\n  margin-bottom: 0;\n}\n\n.section-six-title>span {\n  font-weight: 500;\n}\n\n.section-six-description {\n  font-size: 1em;\n}\n\n.section-six-button {\n  text-decoration: none;\n  color: #030e62;\n  font-size: 1em;\n  font-weight: 600;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  gap: 1em;\n  margin-top: 2em;\n}\n\n.section-six-carrousels-container {\n  display: flex;\n  gap: 2em;\n  width: 40%;\n  margin-right: 8em;\n}\n\n.section-six-third-carrousel {\n  display: none;\n}\n\n.section-six-imgScroll {\n  top: 0rem;\n  width: 100%;\n  position: relative;\n  animation: imgScroll 30s linear infinite;\n}\n\n.section-six-imgScrollReverse {\n  top: -100rem;\n  width: 100%;\n  position: relative;\n  animation: imgScrollReverse 30s linear infinite;\n}\n\n@keyframes imgScroll {\n  0% {\n      top: 0rem;\n  }\n\n  100% {\n      top: -200rem;\n  }\n}\n\n\n@keyframes imgScrollReverse {\n  0% {\n      top: -100rem;\n  }\n\n  100% {\n      top: 10rem;\n  }\n}\n\n.section-six-projectImg {\n  width: 100%;\n  object-fit: cover;\n  height: 30vw;\n}\n\n.footer {\n  background-color: #FFFFFF;\n}\n\n.footer-container {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  align-items: center;\n  margin: 0;\n}\n\n.footer-non-absolute {\n  position: relative;\n  width: 100%;\n  align-items: center;\n  margin: 0;\n  top: 0;\n}\n\n.footer-subcontainer-1 {\n  display: flex;\n  gap: 2em;\n}\n\n.footer-title-container {\n  width: 25em;\n  display: flex;\n  flex-direction: column;\n  gap: 2em;\n\n  margin: 0;\n  margin-top: 6em;\n  margin-left: 10em;\n}\n\n.footer-title {\n  text-align: start;\n  width: 100%;\n  margin: 0;\n  color: #030e62;\n\n  font-size: 2.6em;\n  font-weight: 100;\n}\n\n.footer-button {\n  padding: 1rem;\n  background-color: #030e62;\n  color: #ffffff;\n  border-radius: 0px;\n  width: 12em;\n  border: none;\n\n  font-weight: 300;\n}\n\n.footer-offices-container {\n  color: #000000;\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  padding-left: 3em;\n  gap: 4em !important;\n  z-index: 10;\n}\n\n.footer-office {\n  width: 20%;\n}\n\n.footer-office-title {\n  font-size: 1.2em;\n  font-weight: 600;\n  color: #030e62;\n}\n\n.footer-office>p {\n  margin: 0;\n  margin-bottom: .2em;\n  font-size: .9em;\n}\n\n.scroll-top-button {\n  position: absolute;\n  right: 1em;\n  top: 50%;\n}\n\n.footer-image-and-offices {\n  margin-top: 2.2em;\n  margin-left: 4em;\n}\n\n.footer-image-container {\n  top: 35%;\n  position: absolute;\n  width: 50em;\n  object-fit: contain;\n}\n\n.footer-image {\n  width: 100%;\n  object-fit: contain;\n}\n.footer-image-container>.pos1 {\n  position: absolute;\n  top: 25%;\n  left: 20%;\n  z-index: 50;\n}\n.footer-image-container>.pos2 {\n  position: absolute;\n  top: 17%;\n  left: 55%;\n  z-index: 50;\n}\n.footer-image-container>.pos3 {\n  position: absolute;\n  top: 36%;\n  left: 22%;\n  z-index: 50;\n}\n\n.footer-hex-container {\n    width: 2em;\n    height: 2em;\n    position: absolute;\n    bottom: 2em;\n    left: 50%;\n    transform: translate(-50%, 0);\n    display: flex;\n    justify-content: space-around;\n}\n\n.footer-hex-container::before {\n  content: \"\";\n  z-index: 25;\n  position: absolute;\n  width: 2em;\n  height: 2em;\n  z-index: 0;\n\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  background-color: #030e62;\n\n  clip-path: polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);\n}\n\n\n.footer-hex {\n  z-index: 10;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n\n  position: relative;\n  background-color: #030e62;\n  clip-path: polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);\n}\n\n.footer-hex::before {\n  content: \"\";\n  z-index: 25;\n  position: absolute;\n  width: 1.6em;\n  height: 1.6em;\n\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  background-color: #fff;\n\n  clip-path: polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);\n}\n\n.footer-hex::after {\n  content: \"\";\n  z-index: 25;\n  position: absolute;\n  width: 1em;\n  height: 1em;\n\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  background-color: #030e62;\n\n  clip-path: polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);\n}\n\n.lets-meet-container {\n  color: black;\n  position: absolute;\n  bottom: 5.5em;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: .5em;\n}\n\n.lets-meet-title {\n  font-size: 1.2em;\n  font-weight: 600;\n  color: #030e62;\n\n  margin: 0;\n  padding: 0;\n}\n\n.lets-meet-text {\n  font-size: 1em;\n  font-weight: 300;\n  margin: 0;\n  padding: 0;\n}\n\n.lets-meet-line-decoration {\n  margin-top: 1em;\n  width: 1.5em;\n  height: .5em;\n  background-color: #030e62;\n}\n\n.lets-meet-button {\n  background-color: transparent;\n  color: #030e62;\n  font-size: 1.1em;\n  font-weight: 600;\n  padding: 0;\n  border: none;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.footer-appbar {\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  background-color: #FFFFFF;\n  border-top: 1px solid  rgba(0, 0, 0, 0.2);\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: .5em 1em;\n}\n\n.footer-appbar-rights {\n  font-size: .8em;\n  font-weight: 500;\n  color: #000;\n\n}\n\n.footer-appbar-links {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1em;\n}\n\n.footer-appbar-first-links, .footer-appbar-second-links {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1em;\n}\n\n.footer-appbar-first-links>a, .footer-appbar-second-links>a {\n  /* nowrap text */\n  white-space: nowrap;\n  color: #000;\n  font-size: .9em;\n  text-decoration: none;\n  font-weight: 400;\n}\n\n.footer-appbar-second-links>a  {\n  font-weight: 300;\n}\n\n.footer-appbar-links > .divider {\n  width: 1px;\n  height: 1em;\n  background-color: rgba(0, 0, 0, 0.2);\n} \n\n.footer-appbar-social {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0;\n}\n\n.footer-social-icon {\n  color: #17216f;\n}\n\n.center {\n  width: 500px;\n  height: 500px;\n  display: flex;\n  justify-content: center;\n  margin: 0 auto;\n  align-items: center;\n  position: relative;\n  bottom: 255px;\n}\n\n.container {\n  width: 40px;\n  height: 40px;\n  background: white;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  overflow: hidden;\n  transform: translate(-50%, -50%);\n  clip-path: polygon(0% 50%, 25% 95%, 75% 95%, 100% 50%, 75% 5%, 25% 5%);\n  clip-path: polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);\n}\n\n\n.border {\n  width: 30px;\n  height: 30px;\n  background: #030e62;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  overflow: hidden;\n  transform: translate(-50%, -50%);\n  clip-path: polygon(0% 50%, 25% 95%, 75% 95%, 100% 50%, 75% 5%, 25% 5%);\n  clip-path: polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);\n}\n\n\n.dotfill {\n  width: 0px;\n  height: 0px;\n  background: white;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  overflow: hidden;\n  transform: translate(-50%, -50%);\n  clip-path: polygon(0% 50%, 25% 95%, 75% 95%, 100% 50%, 75% 5%, 25% 5%);\n  clip-path: polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);\n  animation: fillHex 0.4s linear forwards;\n  animation-delay: 7s;\n}\n\n.dot2 {\n  animation-delay: 15s;\n}\n\n\n.dot3 {\n  animation-delay: 27s;\n}\n\n@keyframes fillHex {\n  0% {\n    width: 0px;\n    height: 0px\n  }\n\n  100% {\n    width: 40px;\n    height: 320px\n  }\n}\n\n.logo-colored {\n  position: fixed;\n  top: 0;\n  left: -1em;\n  margin: 0;\n  padding: 0;\n  width: 9em;\n  transition: all .8s;\n  opacity: 0;\n  z-index: 100;\n}\n\n.logo-white,\n.logo-black {\n  width: 4em;\n  position: fixed;\n  left: 1.65em;\n  top: .5em;\n  transition: all .8s;\n  opacity: 0;\n  z-index: 100;\n}\n\n\n.logo-colored-appears,\n.logo-white-appears,\n.logo-black-appears {\n  opacity: 1;\n}\n\n.logoVideo-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  z-index: 1;\n}\n\n.logoVideo-start {\n  position: absolute;\n  opacity: 0;\n}\n\n.logo-heading {\n  z-index: 20;\n  text-transform: uppercase;\n  font-size: 3.5rem;\n  opacity: 0;\n}\n\n.weare-heading-start {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 100;\n  font-stretch: 150%;\n}\n\n.weare-heading-out {\n\n  font-weight: 100;\n  font-stretch: 150%;\n}\n\n.cubes-heading-start {\n\n  font-weight: 100;\n  width: 5em;\n  font-stretch: 150%;\n}\n\n.cubes-heading-out {\n\n  font-weight: 100;\n  font-stretch: 150%;\n}\n\n.navigation-container {\n  position: fixed;\n  top: 1em;\n  right: 1em;\n  z-index: 100;\n}\n\n.navigation-button {\n  cursor: pointer;\n  opacity: 0.7;\n  transition: all .3s;\n}\n\n.navigation-button:hover {\n  opacity: 1;\n}\n\n.menu-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n}\n\n.item-container {\n  height: 50vh;\n  width: 10rem;\n  display: flex;\n  flex-direction: column;\n  opacity: .5;\n  transition: all .3s;\n  cursor: pointer;\n}\n\n.item-container:hover {\n  opacity: 1;\n}\n\n.row {\n  flex-direction: row;\n}\n\n.item {\n  font-weight: 200;\n  font-size: 50px;\n  margin: 0;\n}\n\n.item-top {\n  justify-content: flex-start;\n}\n\n.item-bottom {\n  justify-content: flex-end;\n}\n\n.item-top-text {\n  font-weight: 200;\n  text-transform: uppercase;\n  font-size: 1em;\n  margin: 0;\n}\n\n.item-container-active {\n  opacity: 1;\n}\n\n.item-bottom-decoration {\n  background-color: #FFFFFF;\n  width: 1.8em;\n  height: .3em;\n  margin-top: .5em;\n}\n\n.item2 {\n  font-weight: 100;\n  font-size: 35px;\n  opacity: 0.5;\n  cursor: pointer;\n}\n\n.item2:hover {\n  opacity: 1;\n}\n\n.close-button {\n  cursor: pointer;\n  transition: all .3s;\n  opacity: 0.7;\n}\n\n.close-button:hover {\n  opacity: 1;\n}\n\n\n.right {\n  margin-left: 6%;\n  width: 3px;\n  height: 0;\n  right: 1rem;\n  position: relative;\n  background: linear-gradient(180deg,\n      transparent 30%,\n      rgba(255, 255, 255, 0.5),\n      rgb(255, 255, 255));\n}\n\n.speed-1 {\n  animation: animateRight 3s linear infinite;\n}\n\n.speed-2 {\n  animation: animateRight 5s linear infinite;\n}\n\n.speed-3 {\n  animation: animateRight 7s linear infinite;\n}\n\n.speed-4 {\n  animation: animateRight 9s linear infinite;\n}\n\n.speed-5 {\n  animation: animateRight 11s linear infinite;\n}\n\n.speed-6 {\n  animation: animateRight 13s linear infinite;\n}\n\n.delay-1 {\n  animation-delay: 1s;\n}\n\n.delay-2 {\n  animation-delay: 2s;\n}\n\n.delay-3 {\n  animation-delay: 3s;\n}\n\n.delay-4 {\n  animation-delay: 4s;\n}\n\n.delay-5 {\n  animation-delay: 5s;\n}\n\n.delay-6 {\n  animation-delay: 6s;\n}\n\n\n@keyframes animateRight {\n\n  0%,\n  25% {\n    opacity: 0;\n    height: 0;\n  }\n\n  40% {\n    opacity: 1;\n    height: 100%;\n  }\n\n  55%,\n  100% {\n    height: 100%;\n    opacity: 0;\n  }\n}\n\n.hide {\n  z-index: 2;\n  width: 100%;\n  position: relative;\n  margin: 0 auto;\n  top: 2px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  text-align: center;\n}\n\n.hide2 {\n  z-index: 2;\n  background-color: #030e62;\n  width: 100%;\n  height: 500px;\n  position: relative;\n  margin: 0 auto;\n}\n\n.line-container {\n  width: 100%;\n  height: 300px;\n  margin-bottom: 350px;\n  position: relative;\n}\n\n.wrap {\n  opacity: 0.5;\n  z-index: 1;\n  width: 100%;\n  height: 160%;\n  margin: 0 auto;\n  overflow: hidden;\n}\n\n.line {\n  height: 2px;\n  background-color: white;\n  padding: 1px;\n  margin: 0 auto;\n}\n\n\n.line2 {\n  z-index: 0;\n  height: 1px;\n  padding: 1px;\n  margin: 0 auto;\n  background-color: white;\n  opacity: 0.5;\n}\n\n.line-animate {\n  animation: lineH 1.5s infinite linear;\n}\n\n\n.line-animate-delay {\n  animation-delay: 0.5s;\n}\n\n.left-rotate {\n  -ms-transform: rotate(30deg);\n  -webkit-transform: rotate(30deg);\n  transform: rotate(30deg);\n  top: 76px;\n  position: relative;\n  left: 136px;\n}\n\n.left-rotate2 {\n  -ms-transform: rotate(30deg);\n  -webkit-transform: rotate(30deg);\n  transform: rotate(30deg);\n  position: relative;\n  top: 68px;\n  left: 133px;\n}\n\n.right-rotate {\n  -ms-transform: rotate(-30deg);\n  -webkit-transform: rotate(-30deg);\n  transform: rotate(-30deg);\n  position: relative;\n  bottom: -55px;\n  left: -107px;\n}\n\n.right-rotate2 {\n  -ms-transform: rotate(-30deg);\n  -webkit-transform: rotate(-30deg);\n  transform: rotate(-30deg);\n  position: relative;\n  right: 124px;\n  bottom: -59px;\n}\n\n.line-center-1 {\n  transform: rotate(90deg);\n  position: relative;\n}\n\n.line-center-2 {\n  transform: rotate(90deg);\n  position: relative;\n}\n\n\n\n@keyframes lineH {\n  0% {\n    width: 0%;\n    opacity: 0;\n  }\n\n  10% {\n    opacity: 1;\n  }\n\n  100% {\n    width: 100%;\n    opacity: 0;\n  }\n}\n\n\n.first-center {\n  height: 0px;\n  width: 50%;\n  border-right: 3px solid white;\n  position: absolute;\n  top: 0px\n}\n\n.background {\n\n  height: 100vh !important;\n  opacity: 0.5;\n}\n\n.first-center-animate {\n  animation: firstCenter 2s linear infinite;\n}\n\n@keyframes firstCenter {\n  0% {\n    height: 0px;\n    opacity: 0;\n  }\n\n  10% {\n    height: 0px;\n    opacity: 1;\n  }\n\n  100% {\n    height: 100vh;\n  }\n}\n\n.hide {\n  display: 'hidden'\n}\n\n.global-margin {\n  margin: 0 10rem;\n}\n\n\n#borderLeft {\n  border-left: 5px solid white;\n  position: absolute;\n  height: 30px;\n  top: 0;\n}\n\n#borderBottom {\n  border-bottom: 5px solid white;\n  width: 30px\n}\n\n#boxContent {\n  width: 25rem;\n  padding-left: 2em;\n  font-size: 16px;\n  line-height: 19px;\n  font-weight: 200;\n}\n\n.section-six-margin {\n  margin: 10rem;\n}\n\n.s7-flex {\n  display: flex;\n}\n\n.white-bg {\n  background-color: white;\n}\n\n.s7-height {\n  height: 100vh;\n}\n\n.s7-width {\n  width: 100%;\n}\n\n.s7-transition {\n  transition: background-color 1s ease;\n}\n\n\n/* blinking hexagon */\n\n.white {\n  background: white;\n}\n\n.blue {\n  background: #030e62;\n}\n\n.white-text {\n  color: white !important;\n}\n\n.w-120 {\n  width: 60px;\n  height: 60px;\n}\n\n.w-100 {\n  width: 35px;\n  height: 35px;\n}\n\n.w-80 {\n  width: 31px;\n  height: 31px;\n}\n\n.w-60 {\n  width: 20px;\n  height: 20px;\n}\n\n.animateHex {\n  animation: blink 2s linear infinite;\n}\n\n\n@keyframes blink {\n  0% {\n    width: 0px;\n    height: 0px;\n  }\n\n  100% {\n    width: 65px;\n    height: 65px;\n    opacity: 0;\n  }\n}\n\n\n.w-128 {\n  width: 128px;\n  height: 128px;\n  opacity: 0.1;\n  background: #FFFFFF;\n  position: relative;\n  top: 184px;\n  z-index: 2;\n}\n\n.logo-ignore-position {\n  position: absolute;\n}\n\n\n@media screen and (max-width: 821px) {\n  .logo-colored {\n    top: 1em;\n    left: 0;\n    width: 6em;\n  }\n  \n  .logo-white,\n  .logo-black {\n    width: 2.8em;\n    left: 1.65em;\n    top: 1.2em;\n    transition: all .8s;\n    opacity: 0;\n    z-index: 100;\n  }\n  \n  .navigation-container {\n    top: 2em;\n    right: 2em;\n  }\n\n  \n  .menu-container {\n    flex-direction: column;\n    align-items: flex-start;\n    height: 100vh;\n    padding-left: 3em;\n    padding-top: 5em;\n  }\n\n  .item-container {\n    height: auto;\n  }\n\n  .item {\n    font-size: 25px;\n    margin: 0;\n  }\n\n  .item-top {\n    justify-content: flex-start;\n  }\n\n  .item-bottom {\n    justify-content: flex-start;\n  }\n\n  .item2 {\n    font-weight: 100;\n    font-size: 25px;\n    justify-content: flex-start;\n    margin: 0;\n    padding: 0;\n  }\n\n  #mainContent {\n    width: 100%;\n    height: auto;\n  }\n\n  .logoVideo-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .logoVideo-start {\n    position: absolute;\n    opacity: 0;\n  }\n\n\n\n  .logo-heading {\n    font-size: 2.5em;\n  }\n\n  @keyframes weare-heading-start {\n    0% {\n      opacity: 0;\n      transform: translate(0, -0%);\n    }\n\n    100% {\n      transform: translate(0, -250%);\n      opacity: 1;\n    }\n  }\n\n  @keyframes were-heading-out {\n    0% {\n      opacity: 1;\n      transform: translate(0, -250%);\n    }\n\n    100% {\n      transform: translate(0, -0%);\n      opacity: 0;\n    }\n  }\n\n  @keyframes cubes-heading-start {\n    0% {\n      opacity: 0;\n      transform: translate(0, -0%);\n    }\n\n    100% {\n      transform: translate(0, 300%);\n      opacity: 1;\n    }\n  }\n\n  @keyframes cubes-heading-out {\n    0% {\n      opacity: 1;\n      transform: translate(0, 300%);\n    }\n\n    100% {\n      transform: translate(0, -0%);\n      opacity: 0;\n    }\n  }\n\n  .big-globe-bg-container {\n    width: auto;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  .big-globe-bg {\n    width: auto;\n    height: 100vh;\n    object-fit: contain;\n    z-index: 10;\n  }\n\n  .service-cards-container {\n    width: 100%;\n    height: 75%;\n    display: flex;\n    padding-top: 8em;\n    padding-bottom: 0 !important;\n    margin-bottom: 0 !important;\n\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    z-index: 100;\n  }\n\n  .service-card {\n    width: 80%;\n    padding: .8em 1.5em;\n    margin: 0 auto;\n  }\n\n  .service-card-icon {\n    width: 6em;\n  }\n\n  .companies-container {\n    width: 100%;\n    height: 25%;\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 1em;\n    justify-content: center;\n    padding: 2em 0;\n  }\n\n  .company-logo {\n    width: 7em;\n    object-fit: contain;\n  }\n\n  .section-four-container {\n    justify-content: space-between;\n    align-items: space-between;\n  }\n\n  .pre-sectionFour {\n    height: auto;\n  }\n\n  .section-four-title {\n    font-size: 1.4em;\n    padding: 0 1em;\n    margin: 0;\n    margin-top: 1.5em;\n    width: 100%;\n  }\n\n  .section-four-description {\n    display: none;\n  }\n\n  .section-four-video {\n    position: absolute;\n    width: 100%;\n    height: auto;\n    margin-top: 10em;\n  }\n\n  .section-four-video>video {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n\n\n  .hex-container {\n    width: 70%;\n    height: 10em;\n    position: relative;\n    bottom: 2em;\n    display: flex;\n    justify-content: space-around;\n\n    padding: 0;\n    margin: 0;\n  }\n\n  .hex-item-text {\n    font-size: 1.7em;\n    font-weight: 300;\n    opacity: 0;\n    transition: all 1s;\n    position: absolute;\n    bottom: 2em;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n\n  .hex-item-active>.hex-item-text {\n    opacity: 0;\n  }\n  \n  .hex-item-text-active>.hex-item-text {\n    opacity: 1;\n  }\n\n  .sectionOne {\n    top: 0;\n  }\n\n  .sectionThree {\n    margin-top: 250vh;\n  }\n  \n  .sectionThree, .sectionFour, .sectionFive {\n    position: relative;\n    top: 0;\n    opacity: 1;\n    height: auto;\n  }\n\n  .sectionFive {\n    height: auto;\n    overflow: hidden;\n  }\n\n  .logo-white-mobile {\n    position: absolute;\n    width: 2.8em;\n    left: 1.65em;\n    top: 1.2em;\n    transition: all .8s;\n    z-index: 100;\n  }\n\n  .section-five-container,\n  .section-six-container,\n  .footer-container {\n    position: relative;\n    width: 100%;\n    height: auto;\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    justify-content: center;\n    align-items: center;\n\n    flex-direction: column;\n\n    padding: 0 3em 3em;\n  }\n\n  .section-five-title {\n    left: 0;\n    top: 3em;\n    font-size: 1.4em;\n    font-weight: 100;\n  }\n\n  .section-five-sub-container {\n    position: relative;\n    width: 100%;\n    height: 60%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .section-five-bottom-text {\n    display: none;\n  }\n\n  .section-five-big-text {\n    text-align: start;\n    width: 100%;\n    order: 1;\n  }\n\n  .section-five-big-text>.big-text-title {\n    font-size: 1.4em;\n    font-weight: 300;\n  }\n\n  .section-five-big-text>.p-text {\n    font-size: .8em;\n    font-weight: 100;\n    margin-bottom: 1em;\n  }\n\n  .section-five-img-container {\n    width: 16em;\n    margin-top: 5em;\n    order: 2;\n  }\n\n  .section-five-img-container>img {\n    width: 100%;\n    object-fit: contain;\n  }\n\n  .section-six-container {\n    display: flex;\n    flex-direction: column;\n\n    background-color: transparent;\n    color: #FFFFFF;\n  }\n\n  .section-six-texts-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    width: 100%;\n    padding: 0;\n  }\n\n  .section-six-title {\n    top: 3em;\n    font-size: 1.4em;\n    font-weight: 100;\n  }\n\n  .section-six-title>span {\n    font-weight: 500;\n  }\n\n  .section-six-description {\n    font-size: .8em;\n    font-weight: 100;\n  }\n\n  .section-six-button {\n    text-decoration: none;\n    color: #ffffff;\n    font-size: 1em;\n    font-weight: 600;\n    text-transform: uppercase;\n    display: flex;\n    align-items: center;\n    gap: 1em;\n    margin-top: 2em;\n  }\n\n  .section-six-first-carrousel,\n  .section-six-second-carrousel {\n    display: none;\n  }\n\n  .section-six-carrousels-container {\n    width: 100%;\n    margin-top: 0;\n    margin-right: 0;\n  }\n\n  .section-six-third-carrousel {\n    top: 0rem;\n    width: auto;\n    display: flex;\n    position: relative;\n    height: 25em;\n    margin-top: 2em;\n    gap: 25vw;\n    animation: imgScroll 40s linear infinite;\n  }\n\n  .third-carrousel-item {\n    width: 75vw;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex-direction: column;\n  }\n\n  .third-carrousel-item>img {\n    width: 100%;\n    height: 25em;\n    object-fit: cover;\n    overflow: hidden;\n    margin-bottom: 1em;\n  }\n\n  @keyframes imgScroll {\n    0% {\n      left: 0em;\n    }\n    100% {\n      left: -200em;\n    }\n  }\n\n  .footer.footer-non-absolute {\n    height: auto;\n  }\n  \n  .footer-container {\n    background-color: #ffffff;\n    padding-bottom: 0;\n  }\n\n  .footer-subcontainer-1 {\n    position: relative;\n    width: 100%;\n    justify-content: center;\n    flex-direction: column;\n  }\n\n  .footer-title-container {\n    width: 25em;\n    gap: 2em;\n    margin: 0;\n    margin-top: 3em;\n  }\n\n  .footer-title {\n    text-align: start;\n    width: 100%;\n    color: #030e62;\n\n    font-size: 1.8em;\n    font-weight: 100;\n  }\n\n  .footer-button {\n    padding: .8em 1em;\n  }\n\n  .footer-image-and-offices {\n    margin-top: 2.2em;\n    margin-left: 0;\n\n    width: 100%;\n  }\n\n  .footer-offices-container {\n    color: #000000;\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    padding-left: 0;\n  }\n\n  .footer-offices-carrousel {\n    width: 100%;\n    height: 50%;\n    display: flex;\n    padding-top: 0;\n    padding-bottom: 0 !important;\n    margin-bottom: 0 !important;\n\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    z-index: 100;\n  }\n\n  .footer-office {\n    width: 100%;\n    padding: .8em 1.2em;\n    margin: 0 auto;\n    border: 1px solid #bdbfec;\n  }\n\n  .footer-office-title {\n    font-size: 1.2em;\n    font-weight: 600;\n    color: #030e62;\n  }\n\n  .footer-office>p {\n    margin: 0;\n    margin-bottom: .2em;\n    font-size: .9em;\n  }\n\n\n  .footer-image-container {\n    top: 0;\n    position: relative;\n    width: calc(100% + 6em);\n    margin: 0 -3em;\n    object-fit: contain;\n  }\n\n  .footer-image {\n    width: 100%;\n    object-fit: contain;\n  }\n\n  .lets-meet-container {\n    position: static;\n  }\n\n  .scroll-top-button {\n    display: none;\n  }\n\n  .footer-appbar {\n    position: relative;\n    flex-direction: column;\n    width: calc(100% + 6em);\n    padding: 1em 3em;\n\n    justify-content: flex-start;\n    align-items: flex-start;\n    gap: 1em;\n  }\n  \n  .footer-appbar-rights {\n    order: 2;\n  }\n  \n  .footer-appbar-links {\n    width: 100%;\n    order: 1;\n\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n  \n  .footer-appbar-first-links, .footer-appbar-second-links {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    gap: 0;\n  }\n  \n  .footer-appbar-first-links>a, .footer-appbar-second-links>a {\n    font-size: 1em;\n    font-weight: 500;\n    margin-bottom: .5em;\n  }\n  .footer-appbar-second-links>a {\n    font-weight:300;\n  }\n\n  .footer-appbar-links > .divider {\n    display: none;\n  } \n  \n  .footer-appbar-social {\n    display: flex;\n    align-items: flex-start;\n    order: 3;\n    gap: 0;\n  }\n\n  \n.footer-social-icon {\n  width: 1.5em !important;\n  height: 1.5em !important;\n  color: #17216f;\n}\n\n.footer-hex-container {\n  width: 1.5em;\n  height: 1.5em;\n}\n.footer-hex-container::before {\n  width: 1.5em;\n  height: 1.5em;\n}\n\n.footer-hex::before {\n  width: 1.2em;\n  height: 1.2em;\n}\n\n.footer-hex::after {\n  width: .8em;\n  height: .8em;\n}\n\n.footer-image-container>.pos1,.contact-us-image-container>.pos1 {\n  position: absolute;\n  top: 25%;\n  left: 20%;\n  z-index: 50;\n}\n.footer-image-container>.pos3,.contact-us-image-container>.pos3 {\n  position: absolute;\n  top: 36%;\n  left: 22%;\n  z-index: 50;\n}\n.footer-image-container>.pos2,.contact-us-image-container>.pos2 {\n  position: absolute;\n  top: 17%;\n  left: 55%;\n  z-index: 50;\n}\n\n}\n\n@media screen and (min-width :821px) and (max-width: 1025px) {\n  .sectionOne, .sectionTwo, .sectionThree, .sectionFour, .sectionFive, .sectionSix, .footer {\n    font-size: .8em;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
